import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import {generateGuid} from "../../util/guid";
import Tooltip from "../common/Tooltip";
import * as types from "../../constants/ComponentConstants";
import ValidationMessage from "../common/ValidationMessage";
import Revert from "../common/Revert";
import { Popup } from 'semantic-ui-react';
import mergeDeep from "../../util/mergeDeep";
import Row from "../common/Row";

const LinkInput = (props) => {
    const hasInputMask = !!props.inputmask;
    const hasValue = !!props.value;
    const hasValidationMessage = !!props.validationMessage;
    const validationMessageType = props.validationMessageType;
    const tooltiptype = props.tooltipType || types.TOOLTIP_INFO;
    let value = props.value ? props.value.replace("http://", "https://") : "";
    const sizeClassName = props.size ? "o-col-" + (props.size - 4) : "o-col-12";
    const label = props.label + (props.optional ? " (Optioneel)" : "");
    const validation = hasValidationMessage ? <ValidationMessage message={props.validationMessage} type={validationMessageType} /> : null;
    const maxLength = props.maxLength ? props.maxLength : "";
    const disabled = props.disabled || props.readOnly;
    const id = props.id ? props.id : generateGuid();
    let style = mergeDeep({}, props.style);
    const faIconClassname = props.faIconClassname;

    const surroundingStyle = props.surroundingStyle;

    const differsFromOriginal = props.originalValue ? (props.originalValue || "") !== (props.value || "") : props.value && props.value.replace(props.inputmask, "") !== "" ? true : false;
    const revertable = (props.disabled !== true && props.disabled !== 'true') && differsFromOriginal && !props.hideRevert;

    let info = props.tooltip ?
        <Tooltip isInput text={props.tooltip} tooltipType={tooltiptype} /> :
        ((props.markChange && differsFromOriginal) ? <Tooltip isInput text={`Originele waarde: ${props.originalValue ? props.originalValue : 'leeg'}`} tooltipType={tooltiptype} /> : null);

    const inputClassName = classnames({
        "c-input__field": true,
        "yellowBackground": props.markChange && differsFromOriginal
    });

    const labelClassName = classnames({
        "c-input__label": true,
        "has-value": hasValue
    });

    const containerClassName = classnames({
        "c-input": true,
        "has-value": hasValue,
        "error": hasValidationMessage,
        "warning": hasValidationMessage && validationMessageType === types.ValidationMessageTypes.WARNING,
        "disabled": disabled
    });

    function handleOnKeyUp(event) {
        if (event.which === 13) return props.onEnter ? props.onEnter() : null;
    }

    function handleChange(event) {
        if (props.inputmask.length < (event.target.value ? event.target.value.length : 0)) {
            event.target.value = event.target.value.replace("http://", "https://");
            event.target.value = event.target.value.replace(props.inputmask, "");
        }

        props.onChange(event, props.inputmask);
    }

    if (hasInputMask) {
        value = value.replace(props.inputmask, "");
    }

    return (
        <Row>
        <div className={classnames(["c-linkmask", hasInputMask ? "o-col-4" : "o-col-1"])}>
                {!faIconClassname || <Popup trigger={<a href={hasInputMask ? `${props.inputmask}${value}` : value} target="_blank">
                    <i className={classnames(["fa fa-fw " + faIconClassname, "c-linkicon"])}></i>
                </a>} content={`Test hier je link: ${hasInputMask ? `${props.inputmask}${value}` : value}`} />}&nbsp;
                <b>{props.inputmask}</b>
            </div>
            <div className={sizeClassName}>
                <div className={containerClassName} style={surroundingStyle}>
                    <input
                        id={id}
                        style={style}
                        value={value}
                        disabled={disabled}
                        onChange={handleChange}
                        className={inputClassName}
                        maxLength={maxLength}
                        name={props.name}
                        onKeyUp={handleOnKeyUp}
                        ref={props.hasFocus ? input => input && input.focus() : null} />
                    {props.label ?
                        <label
                            className={labelClassName}
                            htmlFor={id}>
                            {label}
                        </label> : null}
                    {info}
                    {!revertable || <Revert
                        onChange={handleChange}
                        name={props.name}
                        originalValue={props.originalValue} />}
                </div>
                {validation}
            </div>
        </Row>
    );
};

LinkInput.defaultProps = {
    validationMessageType: "ERROR",
    markChange: false,
    style: {}
};

LinkInput.propTypes = {
    name: PropTypes.string.isRequired,
    id: PropTypes.string,
    label: PropTypes.string.isRequired,
    value: PropTypes.string,
    originalValue: PropTypes.string,
    markChange: PropTypes.bool,
    onChange: PropTypes.func,
    maxLength: PropTypes.number,
    tooltip: PropTypes.string,
    tooltipType: PropTypes.string,
    validationMessage: PropTypes.string,
    validationMessageType: PropTypes.string,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    size: PropTypes.number,
    optional: PropTypes.bool,
    style: PropTypes.object,
    surroundingStyle: PropTypes.object,
    inputmask: PropTypes.string,
    hideRevert: PropTypes.bool,
    faIconClassname: PropTypes.string,
    onEnter: PropTypes.func,
	hasFocus: PropTypes.bool
};

export default LinkInput;